import React from "react";
import './Footer.css';

export default function () {
    return (

        <footer className="Footer mt-5 pb-4">

            <div className="container">
                <div className="row">
                    <div className="col-12 col-md-3 pt-5">

                        <h2 className="footer-heading text-white text-center fw-bold p-2">Cryptop </h2>

                        <h3 className="text-white  pt-4">Contact Us</h3>

                        <ul className="list-unstyled">
                            <li className="pt-4">
                                <a href="#" className="text-decoration-none text-white"><i class="bi bi-geo-alt-fill pe-3"></i>

                                    Page  looking Layout
                                </a>
                            </li>

                            <li className="pt-4">
                                <a href="#" className="text-decoration-none text-white pt-2">
                                    <i class="bi bi-telephone-fill pe-3"></i>
                                    +01 1234567890
                                </a>
                            </li>
                            <li className="pt-4">
                                <a href="#" className="text-decoration-none text-white pt-2">
                                    <i class="bi bi-envelope-fill pe-3"></i>


                                    demo@gmail.com

                                </a>
                            </li>
                        </ul>





                    </div>

                    <div className="col-12 col-md-3 pt-5">

                        <h2 className="text-white text-center">Invest Money </h2>

                        <p className="text-white  pt-5">
                            There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour,
                        </p>

                    </div>

                    <div className="col-12 col-md-3 pt-5">
                        <h2 className="text-white text-center">Useful Links</h2>
                        <p className="text-white pt-5">

                            There are many
                            variations of
                            passages of
                            Lorem Ipsum
                            available, but the
                            majority have
                            suffered

                        </p>
                    </div>

                    <div className="col-12 col-md-3 pt-5">
                        <h2 className="text-white ">Newsletter</h2>

                        <input type="text" placeholder="Enter Your Mail " className="input-footer p-2 mt-5 text-white border col-12" />

                        <div className="pt-3">
                            <button type="button" className="last-btn p-2 fw-bold" >

                                SUBSCRIBE

                            </button>
                        </div>

                    </div>

                </div>

                <hr className="text-white" />

            </div>

           

            <p className="text-center text-white">
                © 2024 All Rights Reserved By Free Html Templates
            </p>

        </footer>


    )
}